var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.15448V15.8455C0.502122 15.9628 0.534335 16.0773 0.593391 16.1777C0.652446 16.2781 0.736255 16.3607 0.836369 16.4173C0.936483 16.4739 1.04936 16.5023 1.16362 16.4999C1.27788 16.4974 1.38949 16.464 1.48718 16.4032L13.1936 9.05767C13.2871 8.9996 13.3645 8.91777 13.4181 8.82008C13.4718 8.72238 13.5 8.61214 13.5 8.5C13.5 8.38786 13.4718 8.27762 13.4181 8.17993C13.3645 8.08223 13.2871 8.0004 13.1936 7.94233L1.48718 0.596815C1.38949 0.53597 1.27788 0.502627 1.16362 0.500149C1.04936 0.497671 0.936483 0.526145 0.836369 0.5827C0.736255 0.639255 0.652446 0.721891 0.593391 0.822277C0.534335 0.922662 0.502122 1.03725 0.5 1.15448Z",
    fill: "#7B2928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.138670a6adfa48b64d22bb04f87c4f06.svg";
export { ForwardRef as ReactComponent };